import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { HelpersService } from '../../helpers.service'
import { IntegrationsService } from '../integrations.service'

@Injectable({
  providedIn: 'root'
})
export class ZohoService {
  private builderUrl = ''
  zohoConnected = false
  projectId = this.builderService.selectedProject
  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  constructor(private integrationsService: IntegrationsService, private http: HttpClient, private helpers: HelpersService, private builderService: BuilderService) {
    this.builderUrl = this.helpers.getBuilderUrl()
    this.integrationsService.getIntegrations().subscribe((response) => {
      this.zohoConnected = response.zohoConnected
    })
  }

  /**
   * 1️⃣ Get Zoho Authorization URL
   * (Used if you want to open Zoho login from Angular)
   */
  getAuthUrl(data: any): Observable<any> {
    const payload = {
      ...data,
      projectId: this.projectId
    }
    const params = new URLSearchParams()
    params.set('data', JSON.stringify(payload))
    const url = `${this.builderUrl}zoho-auth-url?${params.toString()}`
    return this.http.get(url, this.options)
  }

  /**
   * 2️⃣ Handle callback after Zoho login
   * Angular receives code → send to WordPress → WordPress stores tokens
   */
  handleCallback(code: string): Observable<any> {
    return this.http.post(
      `${this.builderUrl}zoho-callback?code=${code}`,
      {} // empty body
    )
  }
  getInventoryItems(): Observable<any> {
    return this.http.get(`${this.builderUrl}zoho-get-items?projectId=${this.projectId}`)
  }

  saveInventoryItems() {
    return this.http.post(`${this.builderUrl}zoho-push-items`, {
      projectId: this.projectId
    })
  }
}
